/* @flow */

import { rem } from 'polished';
import { tablet } from '@braindate/ui/lib/token/mediaQuery';
import { baseFontSize } from '@braindate/ui/lib/token/typography';

export default {
  root: {
    fontWeight: 500,
    fontSize: rem(15, baseFontSize),
    marginBottom: 10,

    [tablet]: {
      marginBottom: 0,
    },
  },
  title: {
    marginTop: 8,

    [tablet]: {
      display: 'none',
    },
  },
};
